<template>
  <div class="CuestionarioLactanciaParasitosis">
    <div class="md-title">Lactancia / Parasitosis</div>
  </div>
</template>

<script>
export default {
  name: "CuestionarioLactanciaParasitosis",
  props: {
    preguntas: Object,
    errores: Object
  },
  data() {
    return {};
  }
};
</script>